module.exports = __webpack_public_path__ + "img/ma275.2924286c.png";